/**
 * @file components/RegionalNav/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

import PropTypes from "prop-types";
import ResponsiveNav from "../ResponsiveNav/component";

/**
 * This component renders the Regional navigation level
 *
 * @param {Object} props The component props
 * @returns {React.Component} The RegionalNav component
 */
function RegionalNav({
    path = "",
    gemDepartment = null,
    items = null,
    viewport = "",
}) {
    const navProps = {
        path,
        items,
        viewport,
        gemDepartment,
        className: "regionalNav",
    };

    return <ResponsiveNav {...navProps} />;
}

RegionalNav.propTypes = {
    path: PropTypes.string,
    gemDepartment: PropTypes.object,
    items: PropTypes.array,
    viewport: PropTypes.string,
};

export default RegionalNav;
